import { render, staticRenderFns } from "./common-status.vue?vue&type=template&id=5493dc5a&"
import script from "./common-status.vue?vue&type=script&lang=ts&"
export * from "./common-status.vue?vue&type=script&lang=ts&"
import style0 from "./common-status.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports